module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contract"
  }, [_c('vue-pdf-viewer', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "download-contract",
    attrs: {
      "url": _vm.src,
      "height": _vm.height
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "agree",
    class: {
      'sl-btn-disable': _vm.btnDisable
    },
    attrs: {
      "type": "button",
      "name": "button",
      "disabled": _vm.btnDisable
    },
    on: {
      "click": function($event) {
        _vm.ConfirmBlock = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Views.Contract.agree')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "60px"
    }
  }, [_c('a', {
    staticClass: "contact",
    on: {
      "click": function($event) {
        _vm.ContactBlock = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Views.Contract.contact')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ConfirmBlock),
      expression: "ConfirmBlock"
    }],
    staticClass: "sl-mask-confirm"
  }, [_c('div', {
    staticClass: "sl-block"
  }, [_c('p', {
    staticClass: "sl-block-title"
  }, [_vm._v(_vm._s(_vm.$t('Views.Contract.info')))]), _vm._v(" "), _c('p', {
    staticClass: "sl-block-cnt"
  }, [_vm._v(_vm._s(_vm.$t('Views.Contract.cnt')))]), _vm._v(" "), _c('div', {
    staticClass: "sl-block-btn"
  }, [_c('button', {
    staticClass: "sl-block-cancel",
    on: {
      "click": function($event) {
        _vm.ConfirmBlock = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "sl-block-confirm",
    on: {
      "click": _vm.confirmContract
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.confirm')))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ContactBlock),
      expression: "ContactBlock"
    }],
    staticClass: "sl-mask-confirm"
  }, [_c('div', {
    staticClass: "sl-block-contact"
  }, [_c('i', {
    staticClass: "sl-block-icon",
    on: {
      "click": function($event) {
        _vm.ContactBlock = false
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('p', {
    staticClass: "sl-block-title",
    staticStyle: {
      "padding-bottom": "30px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Views.Contract.tip')))]), _vm._v(" "), _c('p', {
    staticClass: "sl-contact-cnt"
  }, [_vm._v(_vm._s(_vm.$t('Views.Contract.mail')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.$store.state.theme.companyInfo.email))])]), _vm._v(" "), _c('p', {
    staticClass: "sl-contact-cnt"
  }, [_vm._v(_vm._s(_vm.$t('Views.Contract.phone')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.$store.state.theme.companyInfo.phone))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b853f92!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/on-boarding/contract.vue
// module id = 1081
// module chunks = 1